<template>
  <div class="text-center page">
    <div class="item" v-if="result && result.success">
      <div class="weui_msg">
        <div class="weui-msg__icon-area">
          <i class="weui-icon-success weui-icon_msg"></i>
        </div>
        <div class="weui-msg__text-area">
          <h2 class="weui-msg__title">购买完成</h2>
          <p class="weui-msg__desc">完成信息:...</p>
        </div>
        <div class="weui-msg__opr-area">
          <!--<router-link :to="`/shop/${$route.params.token}/${$route.params.openId}`" class="item-btn btn-green">返回商城</router-link>-->
          <router-link :to="window.history.back()" class="item-btn btn-green">返回商城</router-link>
          <!--<a class="item-btn btn-green" @click="window.close()">点击右上角关闭按钮，返回游戏</a>-->
        </div>
      </div>
    </div>

    <div class="item" v-else>
      <div class="weui_msg">
        <div class="weui-msg__icon-area">
          <i class="weui-icon-info weui-icon_msg"></i>
        </div>
        <div class="weui-msg__text-area">
          <h2 class="weui-msg__title">订单查询中...</h2>
        </div>
        <div class="weui-msg__opr-area">
          <a class="item-btn" @click.prevent.stop="refresh">刷新</a>
          <!--<router-link :to="`/shop/${$route.params.token}/${$route.params.openId}`" class="item-btn btn-green">返回商城</router-link>-->
          <router-link :to="window.history.back()" class="item-btn btn-green">返回商城</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import request from '@/utils/request'

  export default {
    name: 'WechatCallback',
    data() {
      return {
        result: null
      }
    },
    created() {
      const params = this.$route.params

      request.post('/api/wechat/query', params).then((result) => {
        this.result = result
      })
    },
    methods: {
      refresh () {
        window.location.reload()
      }
    }
  }
</script>

<style scoped>
  .page {
    height: 100%;
    background-color: #fff;
  }

  .item {
    padding: 10px;
  }

  .item-btn {
    display: block;
    height: 42px;
    line-height: 42px;
    color: #666;
    text-align: center;
    border-radius: 5px;
    margin-bottom: 10px;
    background: -webkit-gradient(linear, left top, left bottom, from(#f6f6f6), to(#e1e1e1));
    background: linear-gradient(#f6f6f6, #e1e1e1);
    border: 1px solid #e1e1e1;
    box-shadow: 0 1px 0 0 #f6f6f6 inset;
  }

  .btn-green {
    color: #FFFFFF;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0, #43C750), color-stop(1, #31AB40));
    background: linear-gradient(#43C750, #31AB40);
    border: 1px solid #2E993C;
    box-shadow: 0 1px 0 0 #69D273 inset;
  }
</style>



// WEBPACK FOOTER //
// callback.vue?01a862b7